import {
  createSelector,
  MemoizedSelector
} from '@ngrx/store';
import { getAllDocuments } from '../documents/document.selectors';
import { USER_COLLECTION_ID } from './user';
import { DxUser } from '@digitaix/types';

export const getAllUsers: MemoizedSelector<any, DxUser[]> = getAllDocuments<DxUser>(USER_COLLECTION_ID);

export const getAllUsersAsOptions = createSelector(
  getAllUsers,
  users => users.map(user => ({ value: user.id, display: user.email })),
);
